export default __webpack_public_path__ + "static/media/opensans-light-webfont.c1ae2c0f.woff";